import { render, staticRenderFns } from "./RemitterGroupEmailCoupon.vue?vue&type=template&id=18e9a2ff"
import script from "./RemitterGroupEmailCoupon.vue?vue&type=script&lang=js"
export * from "./RemitterGroupEmailCoupon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports